module.exports = __webpack_public_path__ + "static/img/up.d8c71d09.svg";